/**
 * @generated SignedSource<<5e80764069b2f4aeba7adaf43c5133a5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AnnouncementCard_chat_SocialsQuery$variables = {
  referenceId: string;
};
export type AnnouncementCard_chat_SocialsQuery$data = {
  readonly socialThread: {
    readonly comments: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly id: string;
          readonly text: UnknownJSON;
        };
      }>;
    };
    readonly reactions: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly id: string;
          readonly text: UnknownJSON;
        };
      }>;
    };
    readonly " $fragmentSpreads": FragmentRefs<"AnnouncementComments_chat_SocialThreadCommentsFragment" | "AnnouncementReactions_chat_SocialThreadReactionsFragment">;
  };
};
export type AnnouncementCard_chat_SocialsQuery = {
  response: AnnouncementCard_chat_SocialsQuery$data;
  variables: AnnouncementCard_chat_SocialsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "referenceId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "referenceId",
    "variableName": "referenceId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "text",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cursor",
  "storageKey": null
},
v6 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "Message",
    "kind": "LinkedField",
    "name": "node",
    "plural": false,
    "selections": [
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "storageKey": null
  },
  (v5/*: any*/)
],
v7 = {
  "alias": null,
  "args": null,
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "endCursor",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasNextPage",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v8 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 1000
  }
],
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "senderId",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "deletedAt",
  "storageKey": null
},
v11 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "value",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AnnouncementCard_chat_SocialsQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "SocialThread",
        "kind": "LinkedField",
        "name": "socialThread",
        "plural": false,
        "selections": [
          {
            "alias": "comments",
            "args": null,
            "concreteType": "CommentsConnection",
            "kind": "LinkedField",
            "name": "__CommentsThread_comments_connection",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "CommentsEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": (v6/*: any*/),
                "storageKey": null
              },
              (v7/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": "reactions",
            "args": null,
            "concreteType": "ReactionsConnection",
            "kind": "LinkedField",
            "name": "__CommentsThread_reactions_connection",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ReactionsEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": (v6/*: any*/),
                "storageKey": null
              },
              (v7/*: any*/)
            ],
            "storageKey": null
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "AnnouncementComments_chat_SocialThreadCommentsFragment"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "AnnouncementReactions_chat_SocialThreadReactionsFragment"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AnnouncementCard_chat_SocialsQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "SocialThread",
        "kind": "LinkedField",
        "name": "socialThread",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v8/*: any*/),
            "concreteType": "CommentsConnection",
            "kind": "LinkedField",
            "name": "comments",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "CommentsEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Message",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      (v3/*: any*/),
                      (v4/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "type",
                        "storageKey": null
                      },
                      (v9/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "createdAt",
                        "storageKey": null
                      },
                      (v10/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "isEdited",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "updatedAt",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ReactionsConnection",
                        "kind": "LinkedField",
                        "name": "reactions",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ReactionsEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Message",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v2/*: any*/),
                                  (v3/*: any*/),
                                  (v9/*: any*/),
                                  (v10/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Conversation",
                        "kind": "LinkedField",
                        "name": "conversation",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "participants",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Reference",
                            "kind": "LinkedField",
                            "name": "reference",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "internal_id",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "AuthorizationResult",
                        "kind": "LinkedField",
                        "name": "canUpdate",
                        "plural": false,
                        "selections": (v11/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "AuthorizationResult",
                        "kind": "LinkedField",
                        "name": "canDelete",
                        "plural": false,
                        "selections": (v11/*: any*/),
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v5/*: any*/)
                ],
                "storageKey": null
              },
              (v7/*: any*/)
            ],
            "storageKey": "comments(first:1000)"
          },
          {
            "alias": null,
            "args": (v8/*: any*/),
            "filters": null,
            "handle": "connection",
            "key": "CommentsThread_comments",
            "kind": "LinkedHandle",
            "name": "comments"
          },
          {
            "alias": null,
            "args": (v8/*: any*/),
            "concreteType": "ReactionsConnection",
            "kind": "LinkedField",
            "name": "reactions",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ReactionsEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Message",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      (v3/*: any*/),
                      (v4/*: any*/),
                      (v9/*: any*/),
                      (v10/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v5/*: any*/)
                ],
                "storageKey": null
              },
              (v7/*: any*/)
            ],
            "storageKey": "reactions(first:1000)"
          },
          {
            "alias": null,
            "args": (v8/*: any*/),
            "filters": null,
            "handle": "connection",
            "key": "CommentsThread_reactions",
            "kind": "LinkedHandle",
            "name": "reactions"
          },
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "reference",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "participantsIds",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "ef784ed7c632533bb7fdf6797208e058",
    "id": null,
    "metadata": {
      "connection": [
        {
          "count": null,
          "cursor": null,
          "direction": "forward",
          "path": [
            "socialThread",
            "comments"
          ]
        },
        {
          "count": null,
          "cursor": null,
          "direction": "forward",
          "path": [
            "socialThread",
            "reactions"
          ]
        }
      ]
    },
    "name": "AnnouncementCard_chat_SocialsQuery",
    "operationKind": "query",
    "text": "query AnnouncementCard_chat_SocialsQuery(\n  $referenceId: String!\n) {\n  socialThread(referenceId: $referenceId) {\n    comments(first: 1000) {\n      edges {\n        node {\n          id\n          text\n          __typename\n        }\n        cursor\n      }\n      pageInfo {\n        endCursor\n        hasNextPage\n      }\n    }\n    reactions(first: 1000) {\n      edges {\n        node {\n          id\n          text\n          __typename\n        }\n        cursor\n      }\n      pageInfo {\n        endCursor\n        hasNextPage\n      }\n    }\n    ...AnnouncementComments_chat_SocialThreadCommentsFragment\n    ...AnnouncementReactions_chat_SocialThreadReactionsFragment\n    id\n  }\n}\n\nfragment AnnouncementComments_chat_SocialThreadCommentsFragment on SocialThread {\n  id\n  reference\n  ...CommentsThread_chat_socialThread\n}\n\nfragment AnnouncementMessageActions_chat_messageFragment on Message {\n  id\n  ...AnnouncementReactionButton_chat_messageFragment\n  deletedAt\n  canUpdate {\n    value\n  }\n  canDelete {\n    value\n  }\n  reactions {\n    edges {\n      node {\n        id\n        deletedAt\n      }\n    }\n  }\n}\n\nfragment AnnouncementReactionButton_chat_messageFragment on Message {\n  id\n  reactions {\n    edges {\n      node {\n        id\n        text\n        senderId\n        deletedAt\n      }\n    }\n  }\n}\n\nfragment AnnouncementReactions_chat_SocialThreadReactionsFragment on SocialThread {\n  id\n  reactions(first: 1000) {\n    edges {\n      node {\n        id\n        text\n        senderId\n        deletedAt\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  ...ReactionButton_chat_socialThreadFragment\n}\n\nfragment CommentsThread_chat_socialThread on SocialThread {\n  id\n  reference\n  participantsIds\n  comments(first: 1000) {\n    edges {\n      node {\n        id\n        type\n        senderId\n        text\n        createdAt\n        deletedAt\n        isEdited\n        updatedAt\n        ...MessageReactions_chat_messageFragment\n        ...ReactionButton_chat_messageFragment\n        ...EditAnnouncementMessage_chat_messageFragment\n        ...AnnouncementMessageActions_chat_messageFragment\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment EditAnnouncementMessage_chat_messageFragment on Message {\n  id\n  text\n  updatedAt\n  deletedAt\n  isEdited\n  conversation {\n    id\n    participants\n    reference {\n      internal_id\n    }\n  }\n}\n\nfragment MessageReactions_chat_messageFragment on Message {\n  id\n  ...ReactionButton_chat_messageFragment\n  reactions {\n    edges {\n      node {\n        id\n        text\n        senderId\n        deletedAt\n      }\n    }\n  }\n}\n\nfragment ReactionButton_chat_messageFragment on Message {\n  id\n  reactions {\n    edges {\n      node {\n        id\n        text\n        senderId\n        deletedAt\n      }\n    }\n  }\n}\n\nfragment ReactionButton_chat_socialThreadFragment on SocialThread {\n  id\n  reactions(first: 1000) {\n    edges {\n      node {\n        id\n        text\n        senderId\n        deletedAt\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "73e15cf4223501548f98a450775d10c8";

export default node;
